<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\midTermManual-1.png" alt="" /></div>
                <div>
                    <p>① Sau khi hoàn thành nội dung bài học và bài tập (tất cả các icon bài học đều chuyển sang màu xanh).</p>
                    <p>② Nhấn vào nút [Thi giữa kỳ] (nếu khóa học có thi giữa kỳ) để tham giam thi giữa kỳ.</p>
                </div>
                <div><img src="/static\images\vi\newManual\exam_new_2.png" alt="" /></div>
                <div>
                    <p>Sau khi nhấn nút [Thi giữa kỳ], màn hình như bên dưới sẽ được hiển thị.</p>
                    <p>③ Chọn bài thi giữa kỳ mà bạn muốn tham gia thi ( một khóa học có thể có nhiều kì thi giữa kỳ). Tại đây bạn cũng có thể chọn loại hiển thị toàn bộ câu hỏi hoặc từng câu trong bài thi.</p>
                    <p>④ Nhấn nút [Bắt đầu kiểm tra] để thực hiện bài thi.</p>
                </div>
                <div><img src="/static\images\vi\newManual\edit_exam_final_2.png" alt="" /></div>
                <div>
                    <p>③ Chọn đáp án đúng vào câu hỏi bạn cần trả lời.</p>
                    <p>④ Nhấn vào nút [Cần xem lại] nếu bạn chưa chắc chắn với câu hỏi này.</p>
                    <p>⑤ Hiển thị danh sách câu hỏi. </p>
                    <p>&nbsp;&nbsp;&nbsp; Câu đang có viền màu đỏ là câu hiện tại bạn đang làm.</p>
                    <p>&nbsp;&nbsp;&nbsp; Câu được tô màu xanh là những câu bạn đã điền đáp án.</p>
                    <p>⑥ Hiển thị danh sách những câu bạn cần xem lại.</p>
                    <p>⑦ Nhấn nút nộp bài sẽ hiện thông báo nộp bài thi.</p>
                    <p>⑧ Nút hiển thị từng câu khi nhấn vào sẽ chuyển sang trạng thái hiển thị từng câu cho bạn.</p>
                </div>
                <div><img src="/static\images\vi\newManual\edit_exam_final3.png" alt="" /></div>
                <div>
                    <p>Sau khi nhấn nút nộp bài thì màn hình thông báo sẽ xuất hiện để xác nhận bạn có chắc chắn muốn nộp bài hay không. Và hiển thị số câu trả lời của bạn.</p>
                    <p>Trong ví dụ dưới đây:</p>
                    <p>Số câu trả lời: 1/5</p>
                    <p>Tức là học viên chỉ mới trả lời được 1 câu trên 5 số câu hỏi của bài thi.</p>
                    <p>⑨ Nhấn nút [Ok] để nộp bài.</p>
                    <p>※ Nếu chưa muốn nộp bài, có thế nhấn dấu [X] hoặc nút [Huỷ] để quay lại màn hình làm bài.</p>
                    <p>※ Nếu hết thời gian làm bài mà vẫn chưa nhấn nút [Nộp bài], thì hệ thống sẽ tự động nộp bài.</p>
                </div>
                <div><img src="/static\images\vi\newManual\edit_exam_final4.png" alt="" /></div>
                <div>
                    <p>Sau khi khi nhấn nộp bài sẽ hiển thị màn hình thông báo kết quả.</p>
                    <p>⑩ Nhấn nút [Chi tiết câu sai] để hiển thị danh sách những câu sai bạn đã làm</p>
                    <p>⑪ Nhấn nút [Xác nhận] để quay lại màn hình mục lục</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn vào biểu tượng thi giữa kì.</p></div>
                <div><p>※ Thi giữa kì bạn không cần phải học xong toàn bộ nội dung trong danh sách bài học.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\exam_test_1.png" alt="" /></div>
                <div><p>② Chọn bài thi giữa kì và nhấn button [Bắt đầu kiểm tra], thì Kì thi giữa kỳ sẽ bắt đầu. Khi nhấn button [Hủy], thì sẽ quay trở lại màn hình Danh sách khóa học.</p></div>
                <div><p>※ Có thể làm bài kiểm tra giữa kỳ bao nhiêu lần cũng được. Việc phán đoán Đậu/Không đậu sẽ dựa vào thành tích cuối cùng.</p></div>
                <div><p>● Loại hiển thị: Hiển thị toàn bộ câu hỏi hoặc chỉ hiển thị từng câu.</p></div>
                <div><p>● Số lần dự thi: Tổng số lần dự thi của bạn.</p></div>
                <div><p>●Điểm số cuối cùng: số điểm cuối cùng của bạn thi được.</p></div>
                <div><p>●Điểm cao nhất: Điểm số cao nhất trong các lần thi.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_5.png" alt="" /></div>
                <div>
                    <p>③ Nhấn vào nút [Danh sách] hiển thị danh sách câu hỏi và danh sách kiểm tra lại.</p>
                    <p>● Câu đang có viền màu đỏ là câu hiện tại bạn đang làm.</p>
                    <p>● Câu được tô màu xanh là những câu bạn đã điền đáp án.</p>
                    <p>● Khi nhấn vào câu hỏi sẽ di đến câu hỏi bạn vừa chọn.</p>
                    <p>④ Nhấn nút nộp bài sẽ hiện thông báo nộp bài thi.</p>
                    <p>⑤ Chọn đáp án đúng vào câu hỏi bạn cần trả lời.</p>
                    <p>⑥ Hiển thị danh sách những câu bạn cần xem lại.</p>
                    <p>⑦ Có thể chuyển đổi câu hỏi bằng biểu tượng [Về trước] hoặc [Đi tiếp] và có chuyển đổi kiểu hiển thị từng câu với nút [Hiển thi từng câu]</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_2.png" alt="" /></div>
                <div>
                    <p>Sau khi nhấn nút nộp bài thì màn hình thông báo sẽ xuất hiện để xác nhận bạn có chắc chắn muốn nộp bài hay không. Và hiển thị số câu trả lời của bạn.</p>
                    <p>Trong ví dụ dưới đây:</p>
                    <p>Số câu trả lời: 1/5</p>
                    <p>Tức là học viên chỉ mới trả lời được 1 câu trên 5 số câu hỏi của bài thi.</p>
                    <p>⑨ Nhấn nút [Ok] để nộp bài.</p>
                    <p>※ Nếu chưa muốn nộp bài, có thế nhấn dấu [X] hoặc nút [Huỷ] để quay lại màn hình làm bài.</p>
                    <p>※ Nếu hết thời gian làm bài mà vẫn chưa nhấn nút [Nộp bài], thì hệ thống sẽ tự động nộp bài.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_3.png" alt="" /></div>
                <div>
                    <p>Sau khi khi nhấn nộp bài sẽ hiển thị màn hình thông báo kết quả.</p>
                    <p>⑩ Nhấn nút [Chi tiết câu sai] để hiển thị danh sách những câu sai bạn đã làm</p>
                    <p>⑪ Nhấn nút [Xác nhận] để quay lại màn hình mục lục</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_4.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/midTerm_manual.vue